import { createElement } from 'react';
import { CustomRenderers } from '../DocumentRenderer';

export const headingRenderer: NonNullable<CustomRenderers['block']>['heading'] = props => {
	const { children, textAlign, level } = props!;

	return createElement(`h${level}`, { style: { textAlign } }, children);
};
